import React, { useCallback, useEffect, useState } from "react";
import ledger from "../../../images/Icons/ledger.png";
import { useParams } from "react-router";
import useLogout from "../../Auth/useLogout";
import axios from "axios";
import config from "../../../config";
import NumberFormatter from "../../../Component/NumberFormatter";

export default function SellerOrderLedger() {
  const params = useParams();
  const logout = useLogout();
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const fecthData = useCallback(async () => {
    setLoading(true);
    try {
      const response = await axios.get(
        `${config.apiUrl}/seller/order-ledger/${params.id}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: config.token,
            Accept: "application/json",
          },
        }
      );
      if (response.status === 200) {
        setData(response.data.data.data);
      }
    } catch (error) {
      if (error.response && error.response.status === 401) {
        logout();
      }
    } finally {
      setLoading(false);
    }
  }, [logout, params.id]);

  useEffect(() => {
    fecthData();
  }, [fecthData]);

  return (
    <>
      <div className="page-content">
        <div className="container-fluid">
          <div className="row-layout mrb1">
            <div className="row-hd-txt">
              <div className="row-hd-txt-left">
                <img src={ledger} alt="icon" />
                <h5>Seller Order Ledger</h5>
              </div>
            </div>
            <div className="row">
              <div className="col-lg-12">
                <div className="ledger-table table-responsive">
                  <table className="table table-bordered m-0">
                    <thead>
                      <tr>
                        <th scope="col">S No.</th>
                        <th scope="col">Transaction Id</th>
                        <th scope="col">Type</th>
                        <th scope="col">Date & Time</th>
                        <th scope="col">Amount</th>
                        <th scope="col">Remaining</th>
                        <th scope="col">More Detail</th>
                      </tr>
                    </thead>
                    <tbody>
                      <>
                        {loading ? (
                          <tr>
                            <td colSpan={7} className="text-center">
                              Loading...
                            </td>
                          </tr>
                        ) : data.length > 0 ? (
                          data.map((item, index) => (
                            <tr key={index}>
                              <td>{index + 1}</td>
                              <td>{item.transaction_id}</td>
                              <td>
                                {" "}
                                {item.type === "credit" && (
                                  <span className="badge bg-success ms-1">Credit</span>
                                )}
                                {item.type === "debit" && (
                                  <span className="badge bg-danger ms-1">Debit</span>
                                )}
                              </td>
                              <td>{item.date_time}</td>
                              <td>
                                Rs{" "}
                                <NumberFormatter
                                  number={item.amount}
                                />
                              </td>
                              <td>
                                Rs{" "}
                                <NumberFormatter
                                  number={item.remaining_balance}
                                />
                              </td>
                              <td className="text-start">
                                {item.payment_mode && (
                                  <>
                                    <b>Payment Mode : </b>
                                    {item.payment_mode}
                                    <br/>
                                  </>
                                )}

                                {item.payment_method && (
                                  <>
                                    <b>Payment Method : </b>
                                    {item.payment_method}
                                    <br/>
                                  </>
                                )}

                                {item.transaction_account_name && (
                                  <>
                                    <b>Account Name : </b>
                                    {item.transaction_account_name}
                                    <br/>
                                  </>
                                )}

                                {item.transaction_account_number && (
                                  <>
                                    <b>Account Number : </b>
                                    {item.transaction_account_number}
                                    <br/>
                                  </>
                                )}

                                {item.transaction_bank_name && (
                                  <>
                                    <b>Bank Name : </b>
                                    {item.transaction_bank_name}
                                    <br/>
                                  </>
                                )}

                                {item.transaction_number && (
                                  <>
                                    <b>Transaction ID : </b>
                                    {item.transaction_number}
                                    <br/>
                                  </>
                                )}
                                
                                {item.description && (
                                  <>
                                    <b>Description : </b>
                                    {item.description}
                                  </>
                                )}
                              </td>
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td colSpan={7} className="text-center">
                              No Data Found!
                            </td>
                          </tr>
                        )
                        }
                      </>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
